// extracted by mini-css-extract-plugin
export var button = "modal-module--button--f8a32";
export var closed = "modal-module--closed--1df77";
export var container = "modal-module--container--5ab66";
export var content = "modal-module--content--9a526";
export var error = "modal-module--error--7c080";
export var fullWidth = "modal-module--full-width--941c9";
export var icons = "modal-module--icons--353c3";
export var modal = "modal-module--modal--4a843";
export var small = "modal-module--small--99bc4";
export var title = "modal-module--title--35494";